import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 7h8v8","key":"svg-0"}],["path",{"d":"M5 11h8v8","key":"svg-1"}]]

const IconChevronsUpRight = createReactComponent('outline', 'chevrons-up-right', 'ChevronsUpRight', __iconNode);

export default IconChevronsUpRight;